export enum GlobalStatus {
  YES = 'YES',
  NO = 'NO',
  Fresher = "Fresher",
  Experience = "Experience"
}